/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Stack } from 'sarsaparilla';

import { SearchResultCardPlaceholder } from 'shared-ui/components/SearchResultCard';

export function TourListPlaceholder() {
    return (
        <Stack>
            <SearchResultCardPlaceholder />
            <SearchResultCardPlaceholder />
        </Stack>
    );
}
